import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AppBaseConfiguration } from '@aston/foundation/app-base.configuration';
import { AUTH_ERRORS } from '@aston/foundation/functions';
import { EMPTY, Observable, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import * as AppStoreActions from '../../root-store/app-store/actions';

@Injectable({
	providedIn: 'root'
})
export class AuthenticationErrorsInterceptor implements HttpInterceptor {

	private config = inject(AppBaseConfiguration)
	private store = inject(Store)

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			catchError(err => {
				switch ((err as HttpErrorResponse)?.status) {
				case 0:
				case 401:
					if (!req.url.includes(this.config.apiUrl)) {
						// an error to an external service should not trigger an auth error
						console.debug(`[http] error calling external service ${req.url}: ${err}`);
						return EMPTY
					}
					if ([err.error?.SpecificError, err.originalError?.error?.SpecificError].includes(AUTH_ERRORS.LoggedInUserDoesNotExists)) {
						this.store.dispatch(AppStoreActions.CriticalFailure({error: err, goToConsole: true}));
					}
					return throwError(() => err);

				default:
					return throwError(() => err);
				}
			})
		);
	}
}
